import Vue from 'vue'

/**
 * 点击后，显示确认提示，确认后删除指定记录.
 *
 * 示例
 * <button v-delete-record="{ method: deleteRecord, record: group, name: group.name }" ></button>
 *
 * deleteRecord (record) {
 *
 * }
 *
 *
 * 还有属性：description， 设置后可以增加删除描述
 */
Vue.directive('delete-record', {
  bind(el, binding) {
    el.modalInfo = binding.value
    el.toggleModalMethod = function() {
      management.$refs.deleteConfirmDialogRef.popup(el.modalInfo.name, el.modalInfo.record, el.modalInfo.method, el.modalInfo.contentHtml)
    }

    el.addEventListener('click', el.toggleModalMethod)
  },
  unbind(el) {
    el.removeEventListener('click', el.toggleModalMethod)
  },
  update(el, { value }) {
    el.modalInfo = value
  }
})
